import { HttpResponse, HttpClient, HttpHeaders, HttpHeaderResponse } from '@angular/common/http';
import * as globals from './globals';
import { Injectable } from '@angular/core';
import { VolatileStorage } from './storage/volatile-storage';
import { Preference } from './storage/preference';
import { AuthenticationResult, SessionInfo } from './data/authentication-info';
import { Observable, throwError } from 'rxjs';
import * as Rx from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { isPresent } from './providers/common-service';
import { MessageDisplayUtil } from './message-display-utils';
import { AlertController, Platform, ToastController } from '@ionic/angular';
/**
 * Created by Ashok on 06-04-2016.
 */
@Injectable()
export class AuthenticationService {
  public static CurrentUser: string = 'CurrentUser';
  private curUser: any;

  constructor(
    private http: HttpClient,
    private preference: Preference,
    private volatileStorage: VolatileStorage,
    private toastCtl: ToastController,
    private alertCtl: AlertController,
    private platform: Platform
  ) {
    preference.getPref(AuthenticationService.CurrentUser).subscribe((data: any) => {
      this.curUser = data;
    });
  }

  /**
   * Checks whether currently signed in or not
   * @returns {boolean} Returns true if signed in and session info exist
   */
  isSignedIn(): boolean {
    let session: SessionInfo = this.volatileStorage.getObject('session');
    return isPresent(session) && isPresent(session.authToken);
  }

  currentUser(): Observable<any> {
    return this.preference.getPref(AuthenticationService.CurrentUser);
  }

  /**
   * Gets the current user from the storage. The current user is one who logged in
   * last
   * @param subscriber The retrieval of current user is asynchronous process.
   * Pass the
   */
  getCurrentUser(): any {
    return this.curUser;
  }

  /**
   * Gets the current session information for the logged in user
   * @returns {SessionInfo} The session info object
   */
  // currentSession(): SessionInfo {
  //     return this.volatileStorage.getObject("session");
  // }

  authenticatePlayer(username: string, password: string): Observable<SessionInfo> {
    let creds = 'email=' + username + '&' + 'password=' + password + '&username=' + username;
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    // this.http.get('https://example.com/api/items').pipe(map(data => {})).subscribe(result => {

    // })

    return this.http
      .post(globals.ServerUrls.authentication, creds, {
        headers: headers,
      })
      .pipe(
        map((res: any) => {
          let data: AuthenticationResult = res.json();
          let sessionInfo: SessionInfo = {
            authToken: data.authToken,
            userId: data.user.userId,
            userName: username,
            password: password,
            userType: data.user.userType,
            playerId: data.user.playerId,
            clubId: data.user.clubId,
            organizerId: data.user.organizerId,
            name: data.name,
            admin: data.user.admin,
          };
          this.volatileStorage.setObject('session', sessionInfo);
          this.volatileStorage.setBoolean('authenticated', true);
          // //Store the current user in preference so that it can be
          // //used for auto login next time
          let curUser = {
            username: username,
            password: password,
          };
          this.preference.setPref(AuthenticationService.CurrentUser, curUser);
          this.curUser = curUser;
          //Call the subscriber
          return sessionInfo;
        })
      );
  }

  authenticate(userName: string, password: string, appType?: string): Observable<AuthenticationResult> {
    // AuthenticationResult
    let _params = {};
    let creds = 'email=' + userName + '&' + 'password=' + password + '&username=' + userName;
    let _url: string; // = globals.ServerUrls.authentication;
    _url = globals.ServerUrls.newAuthentication;
    let _clubId = globals.clubId;
    let _validateClubMember = true;
    let _hdrs = {};
    _hdrs['Content-Type'] = 'application/x-www-form-urlencoded';
    if (globals.appType === 'club' && globals.clubId && appType === 'play') {
      creds += '&clubId=' + _clubId + '&validateClubMember=' + _validateClubMember;
      // creds = "clubId=" + _clubId + "&validateClubMember=" + _validateClubMember + "&" + creds;
      _url = globals.ServerUrls.newAuthentication;
      _params = {
        email: userName,
        password: password,
        username: userName,
        clubId: _clubId,
        validateClubMember: _validateClubMember,
      };
      _hdrs['Accept'] = 'application/json';
    } else if (appType === 'club') {
      _url = globals.ServerUrls.newAuthentication;
      _params = {
        email: userName,
        password: password,
        username: userName,
        // clubId: _clubId,
        // validateClubMember: _validateClubMember
      };
      _hdrs['Accept'] = 'application/json';
    } else {
      // _url = globals.ServerUrls.authentication;
      _url = globals.ServerUrls.newAuthentication;
      _params = {
        email: userName,
        password: password,
        username: userName,
      };
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http
      .post(_url, _params, {
        headers: _hdrs,
        params: _params,
      })
      .pipe(
        map((res: any) => {
          // return this.http.post(globals.ServerUrls.authentication, creds, {
          //     headers: headers
          // })
          // .pipe(map((res: any) => {
          console.debug('auth error : ', res);
          let data: AuthenticationResult = res;
          return data;
        })
      );
  }

  public setCurrenUser(email: string) {
    this.signout();
    let curUser = {
      username: email,
    };
    this.curUser = curUser;
    this.preference.setPref(AuthenticationService.CurrentUser, curUser);
  }

  /**
   * Signout the session. This will clear session and clears the current user password
   */
  public signout() {
    // console.log("[Signout] Get pref 0 : ",this.preference.getUserPreference());
    // console.log("[Signout] Auth Current User 0 : ",AuthenticationService.CurrentUser)
    this.volatileStorage.remove('session');
    this.volatileStorage.remove('authenticated');
    // console.log("[Signout] Get pref 1: ",this.preference.getUserPreference());
    // console.log("[Signout] Auth Current User : ",AuthenticationService.CurrentUser)
    // this.preference.clearUserPreference("CompetitionFilter")
    this.preference.setPref('ScorecardSearchFilter');
    this.preference.setPref('ScorecardSearchScorecardType');

    this.preference.setPref('CompetitionFilter');
    this.preference.setPref('adminSelectedClub');
    // this.pref.setPref("ScorecardSearchFilter");
    // this.pref.setPref("ScorecardSearchScorecardType");

    this.preference.getPref(AuthenticationService.CurrentUser).subscribe((curUser: any) => {
      if (curUser && curUser.password) curUser.password = null;
      this.curUser = curUser;
      this.preference.setPref(AuthenticationService.CurrentUser, curUser);
    });
    // console.log("[Pref] Get pref 2: ",this.preference.getUserPreference());
  }

  private handleError(error) {
    let result: any;
    if (error && error.json) {
      result = error.json();
    } else if (error) {
      result = error;
    } else {
      result = 'Server error occured';
    }
    return throwError(result);
  }

  onTestAuthAccess(clubId, roles) {
    return new Promise<any>(async (resolve, reject) => {
      let confirm = await this.alertCtl.create({
        header: 'Auth Access',
        subHeader: 'Role Manager access',
        inputs: [
          {
            name: 'authEmail',
            placeholder: 'Email address',
            type: 'text',
          },
          {
            name: 'authPassword',
            placeholder: 'Password',
            type: 'password',
          },
        ],
        backdropDismiss: false,
        // message: "Do you want to exit myGolf2u ?",
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {
              confirm.dismiss().then(() => {
                reject(false);
                return false;
              }); // resolve(false);
              // reject(true);
              // return false;
            },
          },
          {
            text: 'Continue',
            handler: data => {
              this.goAuthAccess(data.authEmail, data.authPassword)
                .then((result: any) => {
                  console.debug('Auth ', result, roles);
                  if (result && result.status === 'success') {
                    console.debug('Auth successful ', result.data);
                    if (result.data.success) {
                      let _hasMatch = result.data.user.roles.some(r => roles.includes(r));
                      let _isSuperAdmin = result.data.user.roles.some(r => r.includes('SUPER_ADMIN'));
                      let _isClub = result.data.user.clubId === clubId;
                      console.debug('Auth successful ', _hasMatch, _isClub, clubId, result.data.user.clubId);
                      if (_isSuperAdmin) {
                        this.onSuccessAuthAccess(result.data.user, roles, result.data.authToken);
                        resolve(true);
                        confirm.dismiss().then(() => {
                          // return true;
                        }); // confirm.dismiss(true);
                        // return;
                      } else if (_hasMatch && _isClub) {
                        this.onSuccessAuthAccess(result.data.user, roles, result.data.authToken);
                        resolve(true);
                        confirm.dismiss().then(() => {
                          // return true;
                        }); // confirm.dismiss(true);
                      } else {
                        MessageDisplayUtil.showErrorToast('User has no privileges to access', this.platform, this.toastCtl, 5000, 'bottom');
                      }
                      // resolve(true)
                    } else if (!result.data.success) {
                      this.onFailedAuthAccess(result.data);
                      // reject(true)
                      // confirm.dismiss(false);
                    }
                  }
                })
                .catch(error => {
                  console.debug('Auth error ', error);

                  let _error = null;
                  if (error) _error = error.error.json();
                  let _msg = 'Error';
                  if (_error.errorMessage) _msg = _error.errorMessage;
                  MessageDisplayUtil.showErrorToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
                  // reject(true)
                  // confirm.dismiss(false);
                });
              return false;
            },
          },
        ],
      });
      confirm.onDidDismiss().then(data => {
        let exit = data?.data;
        if (exit) resolve(true);
        if (!exit) reject(true);
        // return exit;
        // if (exit) this.platform.exitApp();
      });
      confirm.present();
    });
  }

  goAuthAccess(email, password) {
    return new Promise((resolve, reject) => {
      this.authenticate(email, password).subscribe(
        data => {
          console.debug('success : ', data);
          resolve({
            status: 'success',
            data: data,
          });
        },
        error => {
          console.debug('error  : ', error);
          reject({
            status: 'failed',
            error: error,
          });
        }
      );
    });
  }

  onSuccessAuthAccess(user, roles: Array<string>, authToken?: string) {
    MessageDisplayUtil.showMessageToast('Successful', this.platform, this.toastCtl, 3000, 'bottom');
  }
  onFailedAuthAccess(error) {
    let _error = error;
    MessageDisplayUtil.showErrorToast(_error.exception + ' : ' + _error.failureType, this.platform, this.toastCtl, 3000, 'bottom');
  }
}
